<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            CREDENCIADOS - REGISTRO DE PAGAMENTO -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col sm="12">
                                <dl class="row mb-0">
                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Protocolo
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <strong>{{
                                            finalizacao.protocolo
                                        }}</strong>
                                        <app-status
                                            v-if="finalizacao.prioritario"
                                            status="PRIORITÁRIO"
                                            class="ml-1"
                                        ></app-status>
                                        <app-status
                                            class="ml-1"
                                            v-if="finalizacao.especial"
                                            status="ESPECIAL"
                                        ></app-status>
                                    </dd>

                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Qtd. de Entregas
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <strong>{{
                                            finalizacao.qtdEntregas
                                        }}</strong>
                                    </dd>

                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Qtd. de Despesas de Viagens
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <strong>{{
                                            finalizacao.qtdDespViagens
                                        }}</strong>
                                    </dd>

                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Qtd. de Anexos
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <strong>{{
                                            finalizacao.qtdAnexos
                                        }}</strong>
                                    </dd>

                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Valor Total
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <strong>{{
                                            finalizacao.valorTotal | currency
                                        }}</strong>
                                    </dd>

                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Status
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <app-status
                                            :status="
                                                finalizacao.statusDescr
                                                    ? finalizacao.statusDescr
                                                    : ''
                                            "
                                        ></app-status>
                                        <app-finalizacao-detalhe-reprovacao
                                            :finalizacao="finalizacao"
                                        ></app-finalizacao-detalhe-reprovacao>
                                        <finalizacao-detalhe-aprovacao-justificada
                                            :finalizacao="finalizacao"
                                        ></finalizacao-detalhe-aprovacao-justificada>
                                    </dd>

                                    <dt
                                        class="
                                            col-xl-2
                                            col-lg-4
                                            col-md-4
                                            col-sm-5
                                            col-xs-6
                                            text-right
                                            pr-0
                                            mb-0
                                            font-weight-normal
                                        "
                                    >
                                        Última Atualização
                                    </dt>
                                    <dd
                                        class="
                                            col-xl-10
                                            col-lg-8
                                            col-md-8
                                            col-sm-7
                                            col-xs-6
                                            mb-0
                                        "
                                    >
                                        <strong>{{
                                            finalizacao.dataAtualizacao
                                                ? $moment(
                                                      finalizacao.dataAtualizacao
                                                  ).format('DD/MM/YYYY HH:mm')
                                                : ''
                                        }}</strong>
                                    </dd>
                                </dl>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <finalizacao-time-line
                                    :finalizacaoServicos="finalizacoesServicos"
                                    :finalizacao="finalizacao"
                                    v-if="mostrarTimeLine"
                                ></finalizacao-time-line>
                            </b-col>
                        </b-row>
                    </b-card-body>
                    <b-card-footer>
                        <slot name="footer" v-bind="finalizacao"></slot>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import FinalizacaoDetalheReprovacao from './FinalizacaoDetalheReprovacao'
import FinalizacaoTimeLine from './FinalizacaoTimeLine'
import FinalizacaoDetalheAprovacaoJustificada from './FinalizacaoDetalheAprovacaoJustificada.vue'

export default {
    props: {
        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        },
        finalizacao: {
            type: Object,
            default: () => ({})
        },
        mostrarTimeLine: {
            type: Boolean,
        }
    },

    data() {
        return {
            operacao: 'DETALHAR'
        }
    },

    components: {
        AppFinalizacaoDetalheReprovacao: FinalizacaoDetalheReprovacao,
        FinalizacaoTimeLine,
        FinalizacaoDetalheAprovacaoJustificada
    }
}
</script>
